import React, { Suspense } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { AuthInitializeGuard } from './@common/auth/components/AuthInitializeGuard';
import { LoaderSegment } from './@common/components/LoaderSegment';
import { EnviromentVariables } from './@common/constants/EnviromentVariables';
import * as RouterUtils from './@common/utils/ReactRouter.utils';
import { ContextInjection } from './ContextInjection';
import { RouteSwitch } from './routing';


interface AppProps { };

const App: React.FC<AppProps> = () => {
  return (
    <ContextInjection>
      <AuthInitializeGuard>

        <Router basename={EnviromentVariables.publicUrl} getUserConfirmation={RouterUtils.getUserConfirmation}>
          <Suspense fallback={<LoaderSegment key="MAIN_APP_LOADER" />}>
            <RouteSwitch />
          </Suspense>
        </Router>

      </AuthInitializeGuard>
    </ContextInjection>
  );
}

export default App;
